export default __webpack_public_path__ + "static/media/background-05@2x.8810822d.jpg";